const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview"
import UserDataManager from "../../../../manager/user_manager";
import ModelData, { IUserData } from '../../../public/model_data';
import GameUtil from "../../../../utility/game_util";
import LanguageManager from "../../../../manager/language_manager";

@ccclass
export default abstract class BankerListView extends ViewBase {

    @property(cc.Label)
    betCount:cc.Label = null

    @property(cc.Label)
    maxRound:cc.Label = null

    @property(cc.Label)
    minRound:cc.Label = null

    @property(cc.Node)
    goBankerBtn:cc.Node = null

    @property(cc.Node)
    noBankerBtn:cc.Node = null

    @property(cc.Node)
    playerItem:cc.Node = null

    @property(cc.Node)
    playersNode:cc.Node = null

    @property(cc.Node)
    noTips:cc.Node = null

    @property(cc.Node)
    findSelf:cc.Node = null

    @property(cc.ScrollView)
    itemScrollView:cc.ScrollView = null

    itemList = []
    myIndex = 0
    allIndex = 0
    updateShow(m_Data){
        this.myIndex = 0
        this.allIndex = m_Data.Data.length
        this.betCount.string = m_Data.Rule.pub_BeDealerLimit
        this.maxRound.string = m_Data.Rule.pub_BeDealerMax
        this.minRound.string = m_Data.Rule.pub_BeDealerMin
        this.goBankerBtn.active = m_Data.BtnType == 1
        this.noBankerBtn.active = m_Data.BtnType != 1
        this.findSelf.active    = m_Data.BtnType != 1
        for (const key in m_Data.Data) {
            if (m_Data.Data.hasOwnProperty(key)) {
                const data = m_Data.Data[key];
                if (this.itemList[key] == null){
                    this.itemList[key] = cc.instantiate(this.playerItem)
                    this.playersNode.addChild(this.itemList[key])
                }
                this.update_list_item(this.itemList[key], data, Number(key))
            }
        }
        
        if (this.allIndex < this.itemList.length){
            for (let index = this.allIndex; index < this.itemList.length; index++) {
                const element = this.itemList[index];
                element.active = false
            }
        }
        this.noTips.active = this.allIndex <= 0
    }

    update_list_item(item: cc.Node, data: any, index: number): void {
        item.active = true
        let self = this
        let indexLab = cc.find("Index", item).getComponent(cc.Label)
        let name = cc.find("Name", item).getComponent(cc.Label)
        let count = cc.find("Gold", item).getComponent(cc.Label)
        let icon = cc.find("Mask/Icon", item).getComponent(cc.Sprite)
        let mySelf = cc.find("IsSelf", item)
        let nv = cc.find('nv',item)
        let nan = cc.find('nan',item);
        nv.active = false;
        nan.active = false;
        indexLab.string = (index + 1).toString()
        this.getUserData(data.id, (palyerData : IUserData)=> {
            name.string = GameUtil.cutStr(palyerData.name)
            icon.spriteFrame = palyerData.avatarSprite
            nv.active = palyerData.gender==2
            nan.active = palyerData.gender == 1;
            count.string = GameUtil.currencyFormatting(Number(data.balance))
            if (data.id == ModelData.instance.roleData.id){
                mySelf.active = true
                self.myIndex = index + 1
            }
            else{
                mySelf.active = false
            }
            
        })
    }

    goFindMySelf(){
        if (this.allIndex <= 8){ return }
        let allIndex = this.allIndex % 2 == 0 ? this.allIndex : this.allIndex + 1
        let index = this.myIndex % 2 == 0 ? this.myIndex : this.myIndex + 1
        this.itemScrollView.scrollToPercentVertical( ((index - 2) / allIndex))
    }

}